import globalIP from '@/GlobelIP';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import {
  CheckPicker,
  Col,
  Drawer,
  Grid,
  IconButton,
  Row,
  SelectPicker,
  Tooltip,
  Whisper
} from 'rsuite';
import ImagesSlides from './ImagesSlide';
import PageNextIcon from '@rsuite/icons/PageNext';
import PagePreviousIcon from '@rsuite/icons/PagePrevious';

export default function AllProductSlide({
  open,
  close,
  setImagesSlide,
  ImagesSlide,
  setDragAndDropImages,
  setIsLoading,setRotationDegrees,setWidthHeight
}) {
  const [productData, setProductData] = useState([]);
  const [selectedImages, setSelectedImages] = useState();
  const [selectedData, setSelectedData] = useState({ name: [], aliasCode: [] });
  const [filterData, setFilterData] = useState({ name: [], aliasCode: [] });
  const [pagination, setPagination] = useState(0);
  const [productAllData, setProductAllData] = useState([]);
  const [selectFilterName, setSelectFilterName] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const {
          data: {
            meta: {
              pagination: { pageCount }
            }
          }
        } = await axios.get(`${globalIP}/api/products?populate=*&pagination[page]=1`);
        const allData = await getAllData(pageCount);
        setProductAllData(allData);
        const paginatedData = paginateData(allData);
        setProductData(paginatedData);
        const [aliasCodeResponse, productNameResponse] = await Promise.all([
          axios.get(`${globalIP}/api/fetchs-aliascd`),
          axios.get(`${globalIP}/api/products-name`)
        ]);

        const aliasCodeSet = new Set(aliasCodeResponse.data.map(item => item.ProductId));
        const generateData = Array.from(aliasCodeSet).map(value => ({
          label: value,
          value: value
        }));

        const productNameSet = new Set(productNameResponse.data.map(item => item.ProductName));
        const generateProductName = Array.from(productNameSet).map(value => ({
          label: value,
          value: value
        }));
        setSelectedData({ aliasCode: generateData, name: generateProductName });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const filteredData = productAllData.filter(filterItem => {
      return (
        (filterData.name.length === 0 && filterData.aliasCode.length === 0) ||
        filterData.name.includes(filterItem.attributes.ProductName) ||
        filterData.aliasCode.includes(filterItem.attributes.ProductId)
      );
    });
    setProductData(paginateData(filteredData));
  }, [filterData]);

  const getAllData = async pageCount => {
    const allData = [];
    for (let page = 1; page <= pageCount; page++) {
      const {
        data: { data }
      } = await axios.get(`${globalIP}/api/products?populate=*&pagination[page]=${page}`);
      allData.push(...data);
    }
    return allData;
  };

  const paginateData = data => {
    const pageSize = 20;
    const paginatedData = [];
    for (let i = 0; i < data.length; i += pageSize) {
      paginatedData.push(data.slice(i, i + pageSize));
    }
    return paginatedData;
  };
  const handleNextPage = () => {
    if (pagination < productData.length - 1) {
      setPagination(prev => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (pagination > 0) {
      setPagination(prev => prev - 1);
    }
  };
  const filterNames = [
    { label: 'Product Name', value: 'name' },
    { label: 'Alias Code', value: 'aliasCode' }
  ];
  const handleKeyNull = value => {
    if (value) {
      const updatedFilterData = {};
      setPagination(0);
      filterNames.forEach(item => {
        updatedFilterData[item.value] = item.value == value ? filterData[item.value] : [];
      });
      setFilterData(updatedFilterData);
    } else {
      const updatedFilterData = {};
      setPagination(0);
      filterNames.forEach(item => {
        updatedFilterData[item.value] = [];
      });
      setFilterData(updatedFilterData);
    }
  };
  const filterPlaceholders = { name: 'Select Product name', aliasCode: 'Select Alias Code' };
  // console.log(selectFilterName);

  return (
    <>
      <Drawer open={open} onClose={close} backdrop="static" size="sm">
        <Drawer.Header>
          <Drawer.Title style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h6 style={{ marginTop: '8px' }}>Products</h6>
            <div style={{ display: 'flex', gap: '15px' }}>
              <Whisper
                trigger="hover"
                placement={'bottom'}
                controlId={`control-id-${'bottom'}`}
                speaker={<Tooltip>Next Page</Tooltip>}
              >
                <IconButton
                  icon={<PageNextIcon />}
                  color="cyan"
                  appearance="primary"
                  onClick={handleNextPage}
                  size="sm"
                />
              </Whisper>
              <Whisper
                trigger="hover"
                placement={'left'}
                controlId={`control-id-${'bottom'}`}
                speaker={<Tooltip>Previous Page</Tooltip>}
              >
                <IconButton
                  icon={<PagePreviousIcon />}
                  appearance="primary"
                  onClick={handlePrevPage}
                  color="cyan"
                  size="sm"
                />
              </Whisper>
            </div>
          </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          <Grid fluid style={{ padding: '10px' }}>
            <Row gutter={20}>
              <Col xs={12} style={{ marginBottom: '20px' }}>
                <SelectPicker
                  data={filterNames}
                  style={{ width: '100%' }}
                  searchable={false}
                  placeholder="Select Filter"
                  onClean={() => handleKeyNull()}
                  onChange={value => {
                    setSelectFilterName(value);
                    handleKeyNull(value);
                  }}
                />
              </Col>
              {selectFilterName != null && (
                <Col xs={12} style={{ marginBottom: '20px' }}>
                  <CheckPicker
                    data={selectedData?.[selectFilterName]}
                    style={{ width: '100%' }}
                    placeholder={filterPlaceholders[selectFilterName]}
                    onChange={value => {
                      setFilterData(prev => ({ ...prev, [selectFilterName]: value }));
                    }}
                  />
                </Col>
              )}
              {productData[pagination]?.map(item => (
                <Col
                  xs={24}
                  key={item.id}
                  style={{
                    display: 'flex',
                    gap: '10px',
                    marginBottom: '5px',
                    alignItems: 'center',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    setImagesSlide(true);
                    setSelectedImages(item);
                  }}
                >
                  <div style={{ height: '80px', width: '80px' }}>
                    <img
                      src={`${globalIP}${item.attributes.CoverImage.data.attributes.url}`}
                      alt=""
                      style={{ width: '100%', height: '100%' }}
                    />
                  </div>
                  <div>
                    <b style={{ fontSize: '12px' }}>Product : {item.attributes.ProductName} </b>
                    <p style={{ fontSize: '11px' }}>Alias Code : {item.attributes.ProductId}</p>
                    <span style={{ fontSize: '10px' }}>
                      Images : {item.attributes.MultipleImage?.data?.length || 0 + 1}
                    </span>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </Drawer.Body>
      </Drawer>
      <ImagesSlides
        open={ImagesSlide}
        close={() => setImagesSlide(false)}
        selectedImages={selectedImages}
        setDragAndDropImages={setDragAndDropImages}
        selectClose={() => {
          close();
          setFilterData({ name: [], aliasCode: [] });
        }}
        setIsLoading={setIsLoading}
        setRotationDegrees={setRotationDegrees}
        setWidthHeight={setWidthHeight}
      />
    </>
  );
}
